"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontStyles = void 0;
function getFontStyles(theme) {
    return {
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontFamily: theme.fontFamily || 'sans-serif',
    };
}
exports.getFontStyles = getFontStyles;
